<div class="stopover-list">
  @if (stopovers.length) {
    <div class="stopover-list__cards">
      @for (stopover of stopovers | slice: 0:62; track stopover.id; let stopoverIndex = $index) {
        <app-stopover-card
          [stopover]="stopover"
          [stopoverIndex]="stopoverIndex"
          [isSelected]="selectedStopovers.includes(stopover)"
          (onSelect)="handleSelect($event)"
          (onUnselect)="handleUnselect($event)"
        ></app-stopover-card>
      }
    </div>
  } @else {
    <div class="stopover-list__cards"></div>
  }

  <div class="stopover-list__map">
    <app-stopovers-map
      [leg]="leg"
      [destinations]="destinations"
      [cityInfoIndex]="selectedCityInfoIndex"
      [selectedStopovers]="selectedStopovers"
    ></app-stopovers-map>
  </div>
</div>
